import { useCallback, useState, Dispatch } from "react";
import { ApiGet, ApiResponse } from "../../helpers/API/ApiData";

type Props = {
  userId: string;
  search: string;
  page: number;
  countPerPage: number;
  setCount: Dispatch<number>;
};

export const useApiFeedback = ({
  userId,
  search,
  page,
  countPerPage,
  setCount,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ApiResponse["data"]["data"]>();
  const [error, setError] = useState<any>();

  const fetchFeedback = useCallback(async () => {
    setLoading(true);

    try {
      const path = `rating/find?Id=${userId}&letter=${search}&page=${page}&limit=${countPerPage}`;
      const res = await ApiGet(path);

      if (res?.data) {
        setData(res.data.data);
        setCount(res.data.count ?? 0);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [userId, search, page, countPerPage, setCount]);

  return { loading, data, error, fetchFeedback };
};
